/**
 * OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPage
 *
 * Page component for OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPage
 * Path: /docs/core-concepts/closed-circuit
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsClosedCircuitENDocScreenView as __OrbDocCoreConceptsClosedCircuitENDocScreenView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitENDocScreenView';
import { OrbDocCoreConceptsClosedCircuitENDocAnalyticsView as __OrbDocCoreConceptsClosedCircuitENDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsClosedCircuitENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPage(_props: OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"The closed circuit","description":"Every interaction is a loop from an event back to the screen, and the compiler checks every edge of it.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/closed-circuit"},{"locale":"ar","path":"/ar/docs/core-concepts/closed-circuit"},{"locale":"sl","path":"/sl/docs/core-concepts/closed-circuit"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsClosedCircuitENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsClosedCircuitENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsClosedCircuitENOrbDocCoreConceptsClosedCircuitENPage;
